import React from 'react'
import { Cell, Pie, PieChart } from 'recharts'

import {
  Container,
  ContainerCheckbox,
  Counter,
  Label,
  PercentLabel,
  StyledCheckbox,
  WrapperChart,
  WrapperText
} from './styles'

export const CheckboxStatus = ({
    label,
    percent,
    count,
    color,
    value,
    onChange,
    defaultChecked
  }) => {
  return (
    <Container>
      <ContainerCheckbox>
        <StyledCheckbox 
          value={value}
          onChange={onChange}
          defaultChecked={defaultChecked}
        />
        <WrapperText>
          <Label color={color}>
            {label}
          </Label>
          <Counter>
            {`${count} ${count === 1 ? 'nota' : 'notas'}`}
          </Counter>
        </WrapperText>
      </ContainerCheckbox>
      
      <WrapperChart>
        <PieChart width={46} height={46}>
          <Pie
            isAnimationActive
            data={[
              { name: 'Main', value: percent },
              { name: 'Transparent', value: (100 - percent) },
            ]}
            dataKey="value"
            innerRadius={18}
            outerRadius={22}
            startAngle={90}
            endAngle={-360 + 90}
          >
            <Cell fill={color} stroke="transparent" />
            <Cell fill="transparent" stroke="transparent" />
          </Pie>
        </PieChart>
        <PercentLabel>{percent}%</PercentLabel>
      </WrapperChart>
    </Container>
  )
}
